module.exports = __webpack_public_path__ + "static/img/sub05.d5f576b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub05.png
// module id = IsI3
// module chunks = 1